import createIcon from '../../createIcon';

/**
 * @component @name SignalCellularOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNSAxTDEyLjkxIDkuNTlMMjEuNSAxOC4xOFYxWk01LjI3IDQuNUw0IDUuNzdMMTAuMzYgMTIuMTNMMS41IDIxSDE5LjIzTDIxLjIzIDIzTDIyLjUgMjEuNzNMNS4yNyA0LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellularOff = createIcon('SignalCellularOff', [
  [
    'path',
    {
      d: 'M21.5 1L12.91 9.59L21.5 18.18V1ZM5.27 4.5L4 5.77L10.36 12.13L1.5 21H19.23L21.23 23L22.5 21.73L5.27 4.5Z',
      key: '1k97o2',
    },
  ],
]);

export default SignalCellularOff;
